import { useEffect } from 'react'
import useTranslatableFlow from 'FlowBuilder/hooks/useTranslatableFlow'
import useFlowTranslate from 'FlowBuilder/hooks/useFlowTranslate'
import './MultipleSelect.scoped.scss'
import Checkbox from 'Shared/components/Checkbox'

export default function MultipleSelect({ answers, response, setResponse, disabled = false, className = '', settings = {} }) {
  const localResponse = (Array.isArray(response) ? response : []).map((r) => +r)
  const maxAnswers = settings?.enableMaxAnswers && settings?.maxAnswers
  const maxReached = maxAnswers && localResponse.length >= maxAnswers
  const { fallback } = useFlowTranslate()

  // Enable Next button without picking any answers
  useEffect(() => {
    if (setResponse) {
      setResponse(localResponse)
    }
  }, [])

  const handleChange = (event) => {
    const value = +event.target.value
    const responseArray = [...localResponse]
    const index = responseArray.indexOf(value)
    if (event.target.checked && index === -1) {
      // Prevent adding more if max reached
      if (maxAnswers && responseArray.length >= maxAnswers) {
        return
      }
      responseArray.push(value)
    } else {
      if (index > -1) {
        responseArray.splice(index, 1)
      }
    }
    setResponse(responseArray)
  }

  const maxAnswersHint = maxAnswers
    ? fallback.selectUpToMaxAnswers.replace(/{{\s*max_answers\s*}}/g, maxAnswers.toString())
    : '';

  return (
    <div className={`answers ${className}`}>
      {maxAnswers && (
        <div className="max-answers-hint" style={{ marginBottom: '0.5rem', fontSize: '0.9em', color: '#666' }}>
          {maxAnswersHint}
        </div>
      )}
      {answers.filter(answer => answer.active).map((answer) => (
        <MultipleSelectAnswer
          answer={answer}
          handleChange={handleChange}
          disabled={disabled || (maxReached && !localResponse.includes(answer.id))}
          localResponse={localResponse}
          key={answer.id}
        />
      ))}
    </div>
  )
}

function MultipleSelectAnswer({ answer, handleChange, disabled, localResponse }) {
  const { answer: answerTranslated } = useTranslatableFlow({ textContent: answer.textContent })

  return <Checkbox
    value={answer.id}
    onChange={handleChange}
    disabled={disabled}
    checked={localResponse.includes(answer.id)}
    label={answerTranslated ?? answer.answer}
    key={answer.digitOrder}
    className="no-margin-bottom"
  />
}
